import { Component, Event, h, Prop, State, Watch } from '@stencil/core';

@Component({
  tag: 'signet-snackbar',
  styleUrl: 'signet-snackbar.scss',
  shadow: false,
})
export class SignetSnackbar {
  /**
   * The position of the snackbar. Can be top-left, top-center, top-right,
   * bottom-left, bottom-center or bottom-right.
   * @example top-left
   */
  @Prop() position:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right' = 'top-right';
  /**
   * The message to be displayed in the snackbar.
   * @example 'This is a snackbar message'
   */
  @Prop() message: string;
  /**
   * The action to be performed when the snackbar is clicked.
   * @example () => { console.log('Snackbar clicked') }
   */
  @Prop({ mutable: true }) open = false;
  /**
   * The duration for which the snackbar should be displayed.
   * @example 3000
   */
  @Prop() autoHideDuration: number | string;
  /**
   * The severity of the snackbar. Can be success, error, warning or info.
   * @example success
   */
  @State() showSnackbar = false;
  /**
   * The width of the snackbar. Can be xs, sm, md, lg, xl or a number.
   * @example xs
   */
  @Prop() severity: 'success' | 'error' | 'warning' | 'info';
  /**
   * The width of the snackbar. Can be xs, sm, md, lg, xl or a number.
   * @example xs
   */
  @Prop() width: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number = 'sm';
// @Prop() actionText: string ;
  /**
   * The action text to be displayed in the snackbar.
   * @example 'Undo'
   */
  @Event() action: () => void;
  /**
   * The close event to be emitted when the snackbar is closed.
   * @example () => { console.log('Snackbar closed') }
   */
  @Event() close: () => void;
  
  @Watch('open')
  handleOpenChange() {
    this.showSnackbar = this.open;

    if (this.open && this.autoHideDuration) {
      setTimeout(() => {
        this.closeSnackbar();
      }, +this.autoHideDuration);
    }
  }

  componentWillRender() {
    this.showSnackbar = this.open;
  }

  closeSnackbar() {
    this.open = false;
    if (this.close) {
      this.close();
    }
  }

  render() {
    const classes = {
      'signet-snackbar': true,
      'top-left': this.position === 'top-left',
      'top-center': this.position === 'top-center',
      'top-right': this.position === 'top-right',
      'bottom-left': this.position === 'bottom-left',
      'bottom-center': this.position === 'bottom-center',
      'bottom-right': this.position === 'bottom-right',
      success: this.severity === 'success',
      warning: this.severity === 'warning',
      info: this.severity === 'info',
      error: this.severity === 'error',
      xs: this.width === 'xs',
      sm: this.width === 'sm',
      md: this.width === 'md',
      lg: this.width === 'lg',
      xl: this.width === 'xl',
      open: this.open,
    };

    return (
      <div class={classes} style={{ width: `${this.width}px` }}>
        <div class="info-container">
          <signet-icon
            icon={
              this.severity === 'success'
                ? 'check_circle'
                : this.severity === 'warning'
                ? 'warning_amber'
                : this.severity === 'info'
                ? 'info_outline'
                : this.severity === 'error'
                ? 'do_not_disturb_on'
                : ''
            }
            class="icon"
          ></signet-icon>
          <span class="message">{this.message}</span>
        </div>
        <div class="action-container">
          {/* <button onClick={() => this.action()} class="action-btn">
            {this.actionText}
          </button> */}
          <signet-icon
            icon="close"
            class="close-icon"
            onClick={() => this.closeSnackbar()}
          />
        </div>
      </div>
    );
  }
}
